<pre class="description container">{{ 'dialog.gdpr' | translate }}</pre>
